import React from "react";
import ProfilePictureBuilder from "./components/ProfilePictureBuilder";
import "./styles.css";

function App() {
  return (
    <div className="App">
      <ProfilePictureBuilder />
    </div>
  );
}

export default App;
